// @flow
import * as React from "react";
import {injectIntl} from "react-intl";
import {reisy, use} from "reisy";

import type {Publishable} from "../api/types.js";
import Flow from "./flow.js";
import Image from "../components/image.js";
import SectionHeader from "./sectionheader.js";

export const styles = reisy`
@namespace Section;

layout: tile;
/*koskLength: 8;*/

Container {
	$Box.box {
		margin: 1.5625em auto;
		$Media.portraitSmall {
			font-size: 12px;
		}
	}

	$CollectionScreen.Contain & {
		flex: 1 1 auto;
	}
}
Fullscreen {
	@extends Helpers.FontSize;
	flex: 1 1 auto;
}

hasBackground {
	color: #fff;
	text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.35);
	position: relative;
	time {
		color: #DADADA;
	}
}

Background {
	@extends Helpers.AbsFull;
	&::after {
		content: "";
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
		background: rgba(0, 0, 0, .3);
	}
}
`;

type Props = {
	content: Publishable;
	position?: string;
	showHeader?: boolean;
	showBackground?: boolean;
	fullscreen?: boolean;
	className?: string;
	intl: any; // TODO: use real Intl Type here.
};

// TODO: maybe instead of displaying an arbitrary position, rather hardcode
// different positions, like `main` for the main content and `aside` for an
// aside element.
// Instead of just a `publishable` and `html` item type, we might have a
// `header` item type for displaying the header information of the content, and
// a `aside` item type for displaying a content aside.

const Section = (props: Props) => {
	const {
		content,
		position = "main",
		layout,
		showHeader = true,
		showBackground = true,
		fullscreen = false,
		root = false,
		hierarchy = [],
		parent = null,
		headingLvl = 2,
	} = props;
	if (content.type === "story") { return null; }

	let items = content.loaded ? content.positions[position] : null;
	const koskLength = content.options.koskLength || styles.koskLength;

	if (!root && koskLength && items && items.length > koskLength) {
		items = items.slice(0, root ? undefined : koskLength);
		items.push({
			type: 'pagenav',
			content: content.id,
			contentType: content.type,
		});
	}

	const {formatMessage} = props.intl;
	const background = showBackground && content.background;

	const layoutObj = (layout || content.options.layout) && {
		layout: layout || content.options.layout,
	};
	const className = props.className || (content.options && content.options.className);

	const tags = content.tags.length > 0 && content.tags.map(tag => `Tag-${tag.name}`);

	return (
		<article {...use(
			styles.Container,
			background && styles.hasBackground,
			background && background.color && {background: background.color},
			fullscreen && styles.Fullscreen,
			className,
			tags && tags
		)} lang={content.locale} id={`section_${content.id}`}>
			{background && background.image &&
				<Image
					style={styles.Background} image={background.image}
					sizes="100vw" cover absolute />}
			{showHeader && <SectionHeader headingLvl={headingLvl} content={content} />}
			{Flow(layoutObj || styles.layout, formatMessage, items, content, hierarchy.concat([content]))}
		</article>
	);
};

export default injectIntl(Section);



// WEBPACK FOOTER //
// ./lib/publishables/section.js